import loadable from '../../utils/loadable';
import LoadingIndicator from '../../components/LoadingIndicator';
import React from 'react';

export const BLTGatewayLoadable = loadable(() => import('./BLTGateway'), { fallback: <LoadingIndicator /> });
export const BLTBeaconLoadable = loadable(() => import('./BLTBeacons'), { fallback: <LoadingIndicator /> });
export const BLTLiveInteractionLoadable = loadable(() => import("./BLTLiveMonitoring"), {fallback: <LoadingIndicator/>});
export const BLTLiveInteractionRoomViewLoadable = loadable(() => import("./BLTLiveMonitoringRoomView"), {fallback: <LoadingIndicator/>});
export const BLTAlertLogsViewLoadable = loadable(() => import("./AlertResolutionLogs"), {fallback: <LoadingIndicator/>});
